// // assets/gift-with-purchase.js
// (function () {
//   'use strict';

//   // ── Shared config ──
//   const GIFT_VARIANT_ID = 52858290274597; // ← Apna Gift Variant ID
//   const THRESHOLD = 1998; // Rupees me

//   let isUpdatingGift = false;
//   let pendingUpdate = false;
//   let giftUpdateTimer = null;
//   let _ownCartCall = false;

//   function sleep(ms) {
//     return new Promise(resolve => setTimeout(resolve, ms));
//   }

//   function triggerGiftUpdate(delay = 300) {
//     toggleCheckoutButton(true);
//     clearTimeout(giftUpdateTimer);
//     giftUpdateTimer = setTimeout(() => updateGift(true), delay);
//   }

//   function toggleCheckoutButton(disabled = true) {
//     const selectors = [
//       'button[name="checkout"]', 'input[name="checkout"]',
//       '.cart__checkout', '.cart__checkout-button', '.button-checkout',
//       '.checkout-button', '#checkout', '[data-checkout-button]',
//       '.cart__dynamic-checkout'
//     ];

//     selectors.forEach(selector => {
//       document.querySelectorAll(selector).forEach(btn => {
//         if (disabled) {
//           btn.disabled = true;
//           btn.style.pointerEvents = 'none';
//           btn.style.opacity = '0.5';
//         } else {
//           btn.disabled = false;
//           btn.style.pointerEvents = 'auto';
//           btn.style.opacity = '1';
//         }
//       });
//     });
//   }

//   function injectDefaultDisabledStyle() {
//     if (document.getElementById('gift-wp-checkout-style')) return;
//     const style = document.createElement('style');
//     style.id = 'gift-wp-checkout-style';
//     style.innerHTML = `
//       button[name="checkout"], input[name="checkout"], .cart__checkout,
//       .cart__checkout-button, .button-checkout, .checkout-button,
//       #checkout, [data-checkout-button], .cart__dynamic-checkout {
//         opacity: 0.5;
//         pointer-events: none;
//       }
//     `;
//     document.head.appendChild(style);
//   }

//   async function fetchCartWithRetry() {
//     for (let i = 0; i < 3; i++) {
//       try {
//         return await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
//       } catch (e) {
//         if (i === 2) throw e;
//         await sleep(200);
//       }
//     }
//   }

//   function computeCartState(cart) {
//     const subtotal = cart.items.reduce((sum, item) => {
//       if (item.variant_id === GIFT_VARIANT_ID) return sum;
//       return sum + (item.final_line_price || (item.price * item.quantity));
//     }, 0) / 100;

//     const hasGift = cart.items.some(item => item.variant_id === GIFT_VARIANT_ID);
//     const isEligible = subtotal > THRESHOLD;

//     return { subtotal, hasGift, isEligible };
//   }

//   // ── Ella 6.5.2 cart UI refresh (NO page reload) ──
//   async function refreshCartUI() {
//     try {
//       const cart = await fetchCartWithRetry();

//       // Method 1: Theme native
//       if (typeof window.halo !== 'undefined') {
//         try {
//           if (typeof window.halo.updateSidebarCart === 'function') {
//             window.halo.updateSidebarCart(cart);
//           }
//           if (typeof window.halo.updateCart === 'function') {
//             window.halo.updateCart(cart);
//           }
//           if (typeof window.halo.initSidebarCart === 'function') {
//             window.halo.initSidebarCart();
//           }
//         } catch (err) {
//           console.warn('[GiftWP] halo methods error:', err);
//         }
//       }

//       // Method 2: Shopify.getCart
//       if (typeof Shopify !== 'undefined' && typeof Shopify.getCart === 'function') {
//         Shopify.getCart(function (c) {
//           if (typeof window.halo !== 'undefined') {
//             if (typeof window.halo.updateSidebarCart === 'function') window.halo.updateSidebarCart(c);
//             if (typeof window.halo.updateCart === 'function') window.halo.updateCart(c);
//           }
//           updateCartCountBubble(c);
//         });
//       }

//       // Method 3: AJAX side cart HTML
//       const isCartPage = document.body.classList.contains('template-cart') ||
//                          window.location.pathname.includes('/cart');

//       if (!isCartPage) {
//         try {
//           const root = (window.routes && window.routes.root) ? window.routes.root : '';
//           const res = await fetch(root + '/cart?view=ajax_side_cart', {
//             cache: 'no-store',
//             headers: { 'Accept': 'text/html' }
//           });

//           if (res.ok) {
//             const html = await res.text();
//             const wrappers = [
//               document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper'),
//               document.querySelector('#halo-cart-sidebar .previewCart-wrapper'),
//               document.querySelector('.previewCart-wrapper'),
//               document.querySelector('#halo-cart-sidebar .previewCartInfo'),
//               document.querySelector('.previewCartInfo'),
//               document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper')
//             ];

//             for (const wrapper of wrappers) {
//               if (wrapper) {
//                 wrapper.innerHTML = html;
//                 wrapper.classList.remove('is-loading');
//                 break;
//               }
//             }
//           }
//         } catch (err) {
//           console.warn('[GiftWP] ajax_side_cart failed:', err);
//         }
//       } else {
//         try {
//           const sectionEl = document.querySelector('#main-cart-items') ||
//                             document.querySelector('[data-cart]') ||
//                             document.querySelector('.cart');
//           const sectionId = sectionEl?.dataset?.id || sectionEl?.dataset?.section || 'main-cart-items';

//           const sectionRes = await fetch(`/?sections=${sectionId}`, { cache: 'no-store' });
//           if (sectionRes.ok) {
//             const data = await sectionRes.json();
//             const html = data[sectionId];
//             if (html) {
//               const parser = new DOMParser();
//               const doc = parser.parseFromString(html, 'text/html');
//               const newContent = doc.querySelector('#main-cart-items') ||
//                                  doc.querySelector('[data-cart-content]') ||
//                                  doc.querySelector('.cart') ||
//                                  doc.body;
//               const current = document.querySelector('#main-cart-items') ||
//                               document.querySelector('[data-cart-content]') ||
//                               document.querySelector('.cart');
//               if (current && newContent) {
//                 current.innerHTML = newContent.innerHTML;
//               }
//             }
//           }
//         } catch (err) {
//           console.warn('[GiftWP] cart page section failed:', err);
//         }
//       }

//       // Method 4: Cart count
//       updateCartCountBubble(cart);

//       // Method 5: Quantity change event
//       setTimeout(() => {
//         document.querySelectorAll(
//           'div.has-items input.item-quantity, .previewCart input.item-quantity, ' +
//           '.cart-item__qty input, input.item-quantity, [name="updates[]"]'
//         ).forEach(input => {
//           input.dispatchEvent(new Event('change', { bubbles: true }));
//         });
//       }, 150);

//       // Extra force (remove case ke liye)
//       setTimeout(() => {
//         if (typeof window.halo !== 'undefined') {
//           fetch('/cart.js', { cache: 'no-store' })
//             .then(r => r.json())
//             .then(c => {
//               if (typeof window.halo.updateSidebarCart === 'function') window.halo.updateSidebarCart(c);
//               if (typeof window.halo.updateCart === 'function') window.halo.updateCart(c);
//               updateCartCountBubble(c);
//             })
//             .catch(() => {});
//         }
//       }, 300);

//     } catch (e) {
//       console.error('[GiftWP] refreshCartUI error:', e);
//     }
//   }

//   function updateCartCountBubble(cart) {
//     if (!cart) return;
//     const count = cart.item_count || 0;

//     const selectors = [
//       '.cart-count', '.cart-count-bubble', '[data-cart-count]',
//       '.header__icon--cart .count', '.site-header__cart-count',
//       '#CartCount', '.cart-link__bubble', '.halo-cart-count',
//       '.previewCart .cartCount', '.cart-count-number',
//       '.header-cart-count', '.cart__count', '#cart-icon-bubble',
//       '.cart-icon .count'
//     ];

//     selectors.forEach(sel => {
//       document.querySelectorAll(sel).forEach(el => {
//         el.textContent = count;
//         if (count > 0) {
//           el.classList.remove('hide', 'hidden', 'd-none', 'visually-hidden');
//           el.style.display = '';
//         }
//       });
//     });

//     document.querySelectorAll('[data-cart-count]').forEach(el => {
//       el.setAttribute('data-cart-count', count);
//     });
//   }

//   async function updateGift(isRealAction = false) {
//     if (isUpdatingGift) {
//       if (isRealAction) toggleCheckoutButton(true);
//       pendingUpdate = true;
//       return;
//     }

//     isUpdatingGift = true;
//     if (isRealAction) toggleCheckoutButton(true);

//     let cartChanged = false;

//     try {
//       // User action ke baad cart settle hone do (race fix)
//       await sleep(isRealAction ? 450 : 300);

//       let cart = await fetchCartWithRetry();
//       let { hasGift, isEligible, subtotal } = computeCartState(cart);

//       console.log('[GiftWP] Check → subtotal:', subtotal, '| eligible:', isEligible, '| hasGift:', hasGift);

//       // ── ADD gift ──
//       if (isEligible && !hasGift) {
//         console.log('[GiftWP] Adding gift');
//         _ownCartCall = true;
//         try {
//           const res = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
//           });
//           if (res.ok) cartChanged = true;
//         } finally {
//           _ownCartCall = false;
//         }
//       }

//       // ── REMOVE gift (DOUBLE CHECK – race fix) ──
//       else if (!isEligible && hasGift) {
//         // Pehle confirm karo ke subtotal sach mein kam hai
//         await sleep(200);
//         cart = await fetchCartWithRetry();
//         const recheck = computeCartState(cart);

//         console.log('[GiftWP] Recheck before remove → subtotal:', recheck.subtotal, '| eligible:', recheck.isEligible);

//         if (!recheck.isEligible && recheck.hasGift) {
//           console.log('[GiftWP] Removing gift (confirmed)');
//           const giftItem = cart.items.find(item => item.variant_id === GIFT_VARIANT_ID);
//           if (giftItem) {
//             _ownCartCall = true;
//             try {
//               const res = await fetch('/cart/change.js', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ id: giftItem.key, quantity: 0 })
//               });
//               if (res.ok) {
//                 cartChanged = true;
//                 await sleep(250);
//               }
//             } finally {
//               _ownCartCall = false;
//             }
//           }
//         } else {
//           console.log('[GiftWP] Gift remove SKIPPED – still eligible after recheck');
//         }
//       }

//     } catch (e) {
//       console.error('[GiftWP] Error:', e);
//     } finally {
//       isUpdatingGift = false;
//     }

//     if (cartChanged) {
//       await sleep(200);
//       await refreshCartUI();
//       setTimeout(async () => {
//         await refreshCartUI();
//         toggleCheckoutButton(false);
//       }, 600);
//       return;
//     }

//     if (pendingUpdate) {
//       pendingUpdate = false;
//       toggleCheckoutButton(true);
//       triggerGiftUpdate(150);
//       return;
//     }

//     toggleCheckoutButton(false);
//   }

//   // ── Intercepts ──
//   function interceptCartRequests() {
//     const originalFetch = window.fetch;
//     window.fetch = function (...args) {
//       const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
//       if (/\/cart\/(add|update|change)/.test(url) && !_ownCartCall) {
//         toggleCheckoutButton(true);
//         const result = originalFetch.apply(this, args);
//         result.then(res => { if (res.ok) triggerGiftUpdate(400); });
//         return result;
//       }
//       return originalFetch.apply(this, args);
//     };
//   }

//   function listenForThemeCartEvents() {
//     document.addEventListener('change', (e) => {
//       if (e.target.matches('input[name="updates[]"], input.quantity, [data-quantity-input], input.item-quantity') && !_ownCartCall) {
//         triggerGiftUpdate(450);
//       }
//     });
//   }

//   function interceptXHRRequests() {
//     const originalOpen = XMLHttpRequest.prototype.open;
//     const originalSend = XMLHttpRequest.prototype.send;

//     XMLHttpRequest.prototype.open = function (method, url, ...rest) {
//       this._gwpUrl = url;
//       return originalOpen.call(this, method, url, ...rest);
//     };

//     XMLHttpRequest.prototype.send = function (...args) {
//       const url = this._gwpUrl || '';
//       if (/\/cart\/(add|update|change)/.test(url) && !_ownCartCall) {
//         toggleCheckoutButton(true);
//         this.addEventListener('load', () => {
//           if (this.status >= 200 && this.status < 300) {
//             triggerGiftUpdate(400);
//           }
//         });
//       }
//       return originalSend.apply(this, args);
//     };
//   }

//   function listenForRemoveClicks() {
//     document.addEventListener('click', (e) => {
//       const target = e.target.closest(
//         '[data-cart-remove], .cart-remove, .cart__remove, .cart-item__remove, ' +
//         'a[href*="/cart/change"], button[name="remove"], [data-remove-item], ' +
//         '.js-remove, cart-remove-button, [data-remove], .previewCartItem-remove'
//       );
//       if (target && !_ownCartCall) {
//         toggleCheckoutButton(true);
//         triggerGiftUpdate(550); // thoda zyada delay – cart settle hone do
//       }
//     });
//   }

//   function startSafetyPoll() {
//     setInterval(() => {
//       if (!isUpdatingGift && !_ownCartCall) {
//         updateGift(false);
//       }
//     }, 4000);
//   }

//   // ── Buy Now ──
//   function setLoading(btn, isLoading) {
//     if (isLoading) {
//       btn.disabled = true;
//       btn.dataset.originalText = btn.textContent;
//       btn.textContent = 'Adding...';
//     } else {
//       btn.disabled = false;
//       btn.textContent = btn.dataset.originalText || 'Buy Now';
//     }
//   }

//   async function handleBuyNow(btn) {
//     if (btn.disabled) return;
//     if (isUpdatingGift || _ownCartCall) return;

//     setLoading(btn, true);

//     const variantId = parseInt(btn.dataset.variantId, 10);
//     if (isNaN(variantId)) {
//       console.error('[BuyNow] Variant ID missing/invalid');
//       setLoading(btn, false);
//       return;
//     }

//     _ownCartCall = true;
//     try {
//       const addRes = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity: 1 })
//       });

//       if (!addRes.ok) {
//         const err = await addRes.json().catch(() => ({}));
//         throw new Error(err.description || 'Product add nahi ho saka');
//       }

//       const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
//       const { hasGift, isEligible } = computeCartState(cart);

//       if (isEligible && !hasGift) {
//         const giftRes = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
//         });
//         if (!giftRes.ok) console.warn('[BuyNow] Gift add fail');
//       }

//       window.location.href = '/checkout';
//     } catch (e) {
//       console.error('[BuyNow] Error:', e);
//       alert('Kuch masla ho gaya. Dobara try karein.');
//       setLoading(btn, false);
//     } finally {
//       _ownCartCall = false;
//     }
//   }

//   function initBuyNowButtons() {
//     document.querySelectorAll('.custom-buy-now-btn').forEach(btn => {
//       if (btn.dataset.bwInit) return;
//       btn.dataset.bwInit = 'true';
//       btn.addEventListener('click', () => handleBuyNow(btn));
//     });
//   }

//   // Init
//   injectDefaultDisabledStyle();

//   document.addEventListener('DOMContentLoaded', () => {
//     interceptCartRequests();
//     interceptXHRRequests();
//     listenForThemeCartEvents();
//     listenForRemoveClicks();
//     startSafetyPoll();
//     initBuyNowButtons();
//     setTimeout(() => updateGift(false), 1000);
//   });

//   document.addEventListener('variant:change', initBuyNowButtons);

//   window.giftWpUpdate = updateGift;
// })();


// assets/gift-with-purchase.js
(function () {
  'use strict';

  // ── Shared config — sirf yahan define hoti hai, poori file me yehi use hoti hai ──
  const GIFT_VARIANT_ID = 52858290274597; // ← Apna Gift Variant ID yahan daalo
  const THRESHOLD = 1998; // Rupees me (cart subtotal isse zyada ho to gift eligible)

  let isUpdatingGift = false;
  let pendingUpdate = false;
  let giftUpdateTimer = null;
  let _ownCartCall = false; // true hone par interceptor apne aap ko ignore karta hai

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function triggerGiftUpdate(delay = 300) {
    // Disable immediately so there's no gap between the trigger and the
    // debounce firing — closes the window where checkout was clickable.
    toggleCheckoutButton(true);
    clearTimeout(giftUpdateTimer);
    giftUpdateTimer = setTimeout(() => updateGift(true), delay);
  }

  // Checkout Button Control - Improved
  function toggleCheckoutButton(disabled = true) {
    const selectors = [
      'button[name="checkout"]', 'input[name="checkout"]',
      '.cart__checkout', '.cart__checkout-button', '.button-checkout',
      '.checkout-button', '#checkout', '[data-checkout-button]',
      '.cart__dynamic-checkout'
    ];

    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(btn => {
        if (disabled) {
          btn.disabled = true;
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.5';
        } else {
          btn.disabled = false;
          btn.style.pointerEvents = 'auto';
          btn.style.opacity = '1';
        }
      });
    });
  }

  function injectDefaultDisabledStyle() {
    if (document.getElementById('gift-wp-checkout-style')) return;
    const style = document.createElement('style');
    style.id = 'gift-wp-checkout-style';
    style.innerHTML = `
      button[name="checkout"], input[name="checkout"], .cart__checkout,
      .cart__checkout-button, .button-checkout, .checkout-button,
      #checkout, [data-checkout-button], .cart__dynamic-checkout {
        opacity: 0.5;
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);
  }

  async function fetchCartWithRetry() {
    for (let i = 0; i < 3; i++) {
      try {
        return await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
      } catch (e) {
        if (i === 2) throw e;
        await sleep(200);
      }
    }
  }

  function computeCartState(cart) {
    const subtotal = cart.items.reduce((sum, item) => {
      if (item.variant_id === GIFT_VARIANT_ID) return sum;
      return sum + (item.final_line_price || (item.price * item.quantity));
    }, 0) / 100;

    const hasGift = cart.items.some(item => item.variant_id === GIFT_VARIANT_ID);
    const isEligible = subtotal > THRESHOLD;

    return { subtotal, hasGift, isEligible };
  }

  // ── Ella 6.5.2 specific cart UI refresh (NO page reload) ──
  // ── Ella 6.5.2 specific cart UI refresh (NO page reload) ──
async function refreshCartUI() {
  try {
    // Fresh cart data lo
    const cart = await fetchCartWithRetry();

    // ========== METHOD 1: Theme ke native functions (sabse best) ==========
    if (typeof window.halo !== 'undefined') {
      try {
        // Sidebar cart update
        if (typeof window.halo.updateSidebarCart === 'function') {
          window.halo.updateSidebarCart(cart);
          console.log('[GiftWP] halo.updateSidebarCart called');
        }
        // Cart page update
        if (typeof window.halo.updateCart === 'function') {
          window.halo.updateCart(cart);
          console.log('[GiftWP] halo.updateCart called');
        }
        // Kabhi-kabhi init bhi chahiye hota hai
        if (typeof window.halo.initSidebarCart === 'function') {
          window.halo.initSidebarCart();
        }
      } catch (err) {
        console.warn('[GiftWP] halo methods error:', err);
      }
    }

    // ========== METHOD 2: Shopify.getCart + halo (official Halothemes style) ==========
    if (typeof Shopify !== 'undefined' && typeof Shopify.getCart === 'function') {
      Shopify.getCart(function (c) {
        if (typeof window.halo !== 'undefined') {
          if (typeof window.halo.updateSidebarCart === 'function') {
            window.halo.updateSidebarCart(c);
          }
          if (typeof window.halo.updateCart === 'function') {
            window.halo.updateCart(c);
          }
        }
        updateCartCountBubble(c);
      });
    }

    // ========== METHOD 3: Direct AJAX side cart HTML replace (Ella ka ajax_side_cart view) ==========
    const isCartPage = document.body.classList.contains('template-cart') ||
                       window.location.pathname.includes('/cart');

    if (!isCartPage) {
      try {
        const root = (window.routes && window.routes.root) ? window.routes.root : '';
        const res = await fetch(root + '/cart?view=ajax_side_cart', {
          cache: 'no-store',
          headers: { 'Accept': 'text/html' }
        });

        if (res.ok) {
          const html = await res.text();

          // Possible wrappers in Ella 6.5.x
          const wrappers = [
            document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper'),
            document.querySelector('#halo-cart-sidebar .previewCart-wrapper'),
            document.querySelector('.previewCart-wrapper'),
            document.querySelector('#halo-cart-sidebar .previewCartInfo'),
            document.querySelector('.previewCartInfo'),
            document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper')
          ];

          for (const wrapper of wrappers) {
            if (wrapper) {
              wrapper.innerHTML = html;
              wrapper.classList.remove('is-loading');
              console.log('[GiftWP] Side cart HTML replaced');
              break;
            }
          }
        }
      } catch (err) {
        console.warn('[GiftWP] ajax_side_cart fetch failed:', err);
      }
    } else {
      // Cart page: sections refresh try karo
      try {
        const sectionEl = document.querySelector('#main-cart-items') ||
                          document.querySelector('[data-cart]') ||
                          document.querySelector('.cart');
        const sectionId = sectionEl?.dataset?.id || sectionEl?.dataset?.section || 'main-cart-items';

        const sectionRes = await fetch(`/?sections=${sectionId}`, { cache: 'no-store' });
        if (sectionRes.ok) {
          const data = await sectionRes.json();
          const html = data[sectionId];
          if (html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector('#main-cart-items') ||
                               doc.querySelector('[data-cart-content]') ||
                               doc.querySelector('.cart') ||
                               doc.body;
            const current = document.querySelector('#main-cart-items') ||
                            document.querySelector('[data-cart-content]') ||
                            document.querySelector('.cart');
            if (current && newContent) {
              current.innerHTML = newContent.innerHTML;
              console.log('[GiftWP] Cart page section replaced');
            }
          }
        }
      } catch (err) {
        console.warn('[GiftWP] cart page section refresh failed:', err);
      }
    }

    // ========== METHOD 4: Cart count / bubble update ==========
    updateCartCountBubble(cart);

    // ========== METHOD 5: Quantity change event (Ella common trick) ==========
    setTimeout(() => {
      const qtyInputs = document.querySelectorAll(
        'div.has-items input.item-quantity, .previewCart input.item-quantity, ' +
        '.cart-item__qty input, input.item-quantity, [name="updates[]"]'
      );
      qtyInputs.forEach(input => {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }, 150);

  } catch (e) {
    console.error('[GiftWP] refreshCartUI fatal error:', e);
  }
}

function updateCartCountBubble(cart) {
  if (!cart) return;
  const count = cart.item_count || 0;

  const selectors = [
    '.cart-count',
    '.cart-count-bubble',
    '[data-cart-count]',
    '.header__icon--cart .count',
    '.site-header__cart-count',
    '#CartCount',
    '.cart-link__bubble',
    '.halo-cart-count',
    '.previewCart .cartCount',
    '.cart-count-number',
    '.header-cart-count',
    '.cart__count',
    '#cart-icon-bubble',
    '.cart-icon .count'
  ];

  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => {
      el.textContent = count;
      if (count > 0) {
        el.classList.remove('hide', 'hidden', 'd-none', 'visually-hidden');
        el.style.display = '';
      }
    });
  });

  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.setAttribute('data-cart-count', count);
  });
}

  function updateCartCountBubble(cart) {
    if (!cart) return;
    const count = cart.item_count || 0;

    // Common selectors used in Ella / Halothemes
    const selectors = [
      '.cart-count',
      '.cart-count-bubble',
      '[data-cart-count]',
      '.header__icon--cart .count',
      '.site-header__cart-count',
      '#CartCount',
      '.cart-link__bubble',
      '.halo-cart-count',
      '.previewCart .cartCount'
    ];

    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.textContent = count;
        if (count > 0) {
          el.classList.remove('hide', 'hidden', 'd-none');
          el.style.display = '';
        } else {
          // optionally hide when empty
        }
      });
    });

    // Also update any data attributes
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.setAttribute('data-cart-count', count);
    });
  }

  async function updateGift(isRealAction = false) {
    if (isUpdatingGift) {
      if (isRealAction) toggleCheckoutButton(true);
      pendingUpdate = true;
      return;
    }

    isUpdatingGift = true;

    if (isRealAction) {
      toggleCheckoutButton(true);
    }

        let cartChanged = false;

    try {
      await sleep(300);
      const cart = await fetchCartWithRetry();
      const { hasGift, isEligible } = computeCartState(cart);
      const needsChange = (isEligible && !hasGift) || (!isEligible && hasGift);

      if (needsChange) {
        toggleCheckoutButton(true);

        _ownCartCall = true;
        try {
          if (isEligible && !hasGift) {
            console.log('[GiftWP] Adding gift');
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
            });
            if (res.ok) cartChanged = true;

          } else if (!isEligible && hasGift) {
            console.log('[GiftWP] Removing gift');
            const giftItem = cart.items.find(item => item.variant_id === GIFT_VARIANT_ID);
            if (giftItem) {
              const res = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: giftItem.key, quantity: 0 })
              });
              if (res.ok) {
                cartChanged = true;
                // Remove ke baad theme ko thoda time do
                await sleep(250);
              }
            }
          }
        } finally {
          _ownCartCall = false;
        }
      }

    } catch (e) {
      console.error('[GiftWP] Error:', e);
    } finally {
      isUpdatingGift = false;
    }

    // Cart changed → refresh UI (add + remove dono ke liye)
    if (cartChanged) {
      // Extra delay specially for remove case (theme AJAX settle hone do)
      await sleep(200);
      await refreshCartUI();

      // Dobara force refresh (remove case mein kabhi-kabhi pehli baar miss hota hai)
      setTimeout(async () => {
        await refreshCartUI();
        toggleCheckoutButton(false);
      }, 600);

      return;
    }

    if (pendingUpdate) {
      pendingUpdate = false;
      toggleCheckoutButton(true);
      triggerGiftUpdate(150);
      return;
    }

    // Nothing changed, nothing pending — safe to re-enable now.
    toggleCheckoutButton(false);
  }

  // Intercepts
  function interceptCartRequests() {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      if (/\/cart\/(add|update|change)/.test(url) && !_ownCartCall) {
        toggleCheckoutButton(true);
        const result = originalFetch.apply(this, args);
        result.then(res => { if (res.ok) triggerGiftUpdate(350); });
        return result;
      }
      return originalFetch.apply(this, args);
    };
  }

  function listenForThemeCartEvents() {
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[name="updates[]"], input.quantity, [data-quantity-input], input.item-quantity') && !_ownCartCall) {
        triggerGiftUpdate(400);
      }
    });
  }

  function interceptXHRRequests() {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this._gwpUrl = url;
      return originalOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      const url = this._gwpUrl || '';
      if (/\/cart\/(add|update|change)/.test(url) && !_ownCartCall) {
        toggleCheckoutButton(true);
        this.addEventListener('load', () => {
          if (this.status >= 200 && this.status < 300) {
            triggerGiftUpdate(350);
          }
        });
      }
      return originalSend.apply(this, args);
    };
  }

  function listenForRemoveClicks() {
    document.addEventListener('click', (e) => {
      const target = e.target.closest(
        '[data-cart-remove], .cart-remove, .cart__remove, .cart-item__remove, ' +
        'a[href*="/cart/change"], button[name="remove"], [data-remove-item], ' +
        '.js-remove, cart-remove-button, [data-remove], .previewCartItem-remove'
      );
      if (target && !_ownCartCall) {
        toggleCheckoutButton(true);
        triggerGiftUpdate(500);
      }
    });
  }

  function startSafetyPoll() {
    setInterval(() => {
      if (!isUpdatingGift && !_ownCartCall) {
        updateGift(false);
      }
    }, 3000);
  }
// ────────────────────────────────────────────────────────────────
// Custom "Buy Now" button (product page + quickview)
// ────────────────────────────────────────────────────────────────

function setLoading(btn, isLoading) {
  if (isLoading) {
    btn.disabled = true;
    btn.dataset.originalText = btn.textContent;
    btn.textContent = 'Adding...';
  } else {
    btn.disabled = false;
    btn.textContent = btn.dataset.originalText || 'Buy Now';
  }
}

// Quantity nikaalne ka robust helper (Ella + most themes)
function getSelectedQuantity(btn) {
  // Button ke aas-paas form / product block se dhundo
  const container = btn.closest(
    'form, .product-form, .product, .product-single, .product-info, ' +
    '.quickview, .modal, .halo-modal, [data-product], .productView'
  ) || document;

  // Common quantity selectors (Ella 6.x ke liye bhi)
  const selectors = [
    'input[name="quantity"]',
    'input.quantity',
    'input.qty',
    'input[name="qty"]',
    '[data-quantity-input]',
    '.quantity__input',
    '.product-form__quantity input',
    '.js-qty input',
    '.quantity-selector input',
    'input.item-quantity',
    'input[type="number"][min]'
  ];

  for (const sel of selectors) {
    const input = container.querySelector(sel);
    if (input) {
      const val = parseInt(input.value, 10);
      if (!isNaN(val) && val > 0) {
        console.log('[BuyNow] Quantity found:', val, 'from', sel);
        return val;
      }
    }
  }

  // Last fallback – agar kuch nahi mila
  console.warn('[BuyNow] Quantity input nahi mila, 1 use kar raha hoon');
  return 1;
}

async function handleBuyNow(btn) {
  if (btn.disabled) return;
  if (isUpdatingGift || _ownCartCall) return;

  setLoading(btn, true);

  const variantId = parseInt(btn.dataset.variantId, 10);
  if (isNaN(variantId)) {
    console.error('[BuyNow] Variant ID missing/invalid');
    setLoading(btn, false);
    return;
  }

  const quantity = getSelectedQuantity(btn);
  console.log('[BuyNow] Final quantity:', quantity);

  _ownCartCall = true;

  try {
    // 1. Variant price
    let productPrice = 0;
    try {
      const variantRes = await fetch(`/variants/${variantId}.js`, { cache: 'no-store' });
      if (variantRes.ok) {
        const variant = await variantRes.json();
        productPrice = (variant.price || 0) / 100;
      }
    } catch (err) {
      console.warn('[BuyNow] Variant price fetch fail:', err);
    }

    // 2. Current cart
    const cart = await fetchCartWithRetry();
    const { hasGift, subtotal } = computeCartState(cart);

    // 3. Projected subtotal
    const projectedSubtotal = subtotal + (productPrice * quantity);
    const willBeEligible = projectedSubtotal > THRESHOLD;

    console.log('[BuyNow] projected:', projectedSubtotal, '| eligible:', willBeEligible, '| hasGift:', hasGift);

    // 4. Pehle product add karo (quantity ke saath)
    const addProductRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    });

    if (!addProductRes.ok) {
      const err = await addProductRes.json().catch(() => ({}));
      console.error('[BuyNow] Product add failed:', err);
      throw new Error(err.description || err.message || 'Product add nahi ho saka');
    }

    // 5. Agar gift chahiye to alag se add karo
    if (willBeEligible && !hasGift) {
      console.log('[BuyNow] Gift add kar raha hoon...');
      const giftRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: GIFT_VARIANT_ID,
          quantity: 1
        })
      });

      if (!giftRes.ok) {
        // Gift fail ho to bhi product already add ho chuka hai, checkout pe chale jao
        console.warn('[BuyNow] Gift add fail hua, lekin product add ho gaya');
      }
    }

    // 6. Checkout
    window.location.href = '/checkout';

  } catch (e) {
    console.error('[BuyNow] Error:', e);
    // Real error dikhao (debugging ke liye)
    alert(e.message || 'Kuch masla ho gaya. Dobara try karein.');
    setLoading(btn, false);
  } finally {
    _ownCartCall = false;
  }
}

// Event Delegation – Quickview + Product page dono ke liye
function initBuyNowDelegation() {
  if (window._buyNowDelegated) return;
  window._buyNowDelegated = true;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.custom-buy-now-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    handleBuyNow(btn);
  });
}

  // Init
  injectDefaultDisabledStyle();

document.addEventListener('DOMContentLoaded', () => {
  interceptCartRequests();
  interceptXHRRequests();
  listenForThemeCartEvents();
  listenForRemoveClicks();
  startSafetyPoll();
  
  // ← yeh naya
  initBuyNowDelegation();
  
  setTimeout(() => updateGift(false), 1000);
});

  // document.addEventListener('variant:change', initBuyNowButtons);

  window.giftWpUpdate = updateGift;
})();